import {
  parsePhoneNumber,
  getCountryCallingCode,
  getCountries,
  isPossiblePhoneNumber
} from "libphonenumber-js";

export class PhoneNumberFormatter {

  validateNumber(phoneNumber, twoDigitCountryCode) {
    if (twoDigitCountryCode) {
      const numberIsValid = isPossiblePhoneNumber(phoneNumber, twoDigitCountryCode);
      const pattern = /^\d+$/;

      if (!numberIsValid || !pattern.test(phoneNumber)) {
        return false;
      }
      return true;
    }
    return false
  }

  formatInternational(phoneNumber, twoDigitCountryCode) {
    let parsedPhoneNumber = parsePhoneNumber(phoneNumber, twoDigitCountryCode);
    const numberInInternationalFormat = parsedPhoneNumber.formatInternational();
    const formatted = this.replaceLeadingPlus(numberInInternationalFormat);
    // remove spaces from number and return
    return formatted.replaceAll(' ', '');
  }

  replaceLeadingPlus(number) {
    if (number.charAt(0) === '+') {
      return number.replace('+', '00');
    }
    return number;
  }

  formatCountryCode(twoDigitCountryCode) {
    return `${twoDigitCountryCode} +${getCountryCallingCode(twoDigitCountryCode)}`;
  }

  getCountryCodes() {
    return getCountries();
  }

  getPhoneFieldMask(country) {
    let maxPhonenumberLength = this.getPhoneNumberMaxLength(country);
    let dummyNumber = '1'.repeat(maxPhonenumberLength);

    const formattedPlaceholder = parsePhoneNumber(dummyNumber, country);
    const placeholderInInternationalFormat = formattedPlaceholder.formatInternational();

    const placeholder = placeholderInInternationalFormat.replaceAll('1', 'X')
    const countryCallingCode = getCountryCallingCode(country)

    return placeholder.slice(countryCallingCode.length + 1).replaceAll(' ', '');
  }

  getPhoneNumberMaxLength(country) {
   let maxLength = 0;
   for (let len = 1; len <= 20; len++) {
      const testNumber = '1'.repeat(len);
      if (isPossiblePhoneNumber(testNumber, country)) {
        maxLength = len;
      }
   }
   return maxLength;
  }

  getPhoneNumberMinLength(country) {
    let minLength = 0;

    for (let len = 1; len < 15; len ++) {
      const testNumber = '1'.repeat(len)
      if (this.validateNumber(testNumber, country)) {
        minLength = len;
        break;
      }
    }
    return minLength;
  }
}